import type { EnemyConfig } from '../../entities/EnemyConfig';

export const KANGAROO_JOEY_CONFIG: EnemyConfig = {
  id: 'kangaroo_joey',
  displayName: 'Кенгурёнок',
  maxHp: 1,
  speed: 150,
  movementBehavior: 'chase',
  size: 16,
  color: 0xd4a06a,
  scoreReward: 4,
};
